import React from 'react';
import { useField } from 'formik';
import { InputGroup, Input as ReactstrapInput } from 'reactstrap';

interface AmountWithUnitInputProps {
  amountName: string;
  unitName: string;
  availableUnits: string[];
  currentUnit: string;
  onUnitChange: (newUnit: string) => void;
  onAmountChange?: () => void;
  step?: number;
}

const AmountWithUnitInput: React.FC<AmountWithUnitInputProps> = ({
  amountName,
  unitName,
  availableUnits,
  currentUnit,
  onUnitChange,
  onAmountChange,
  step = 0.1,
}) => {
  const [amountField, amountMeta, amountHelpers] = useField(amountName);
  const [unitField] = useField(unitName);

  const handleAmountChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    if (value === '') {
      amountHelpers.setValue('');
    } else {
      const number = +value;
      const roundedValue = Math.round(number * 100) / 100;
      amountHelpers.setValue(roundedValue);
    }
    if (onAmountChange) {
      onAmountChange();
    }
  };

  const handleUnitChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newUnit = e.target.value;
    unitField.onChange(e);
    onUnitChange(newUnit);
  };

  return (
    <InputGroup
      className={amountMeta.touched && amountMeta.error ? 'is-invalid flex-nowrap' : 'flex-nowrap'}
      style={{ overflow: 'hidden' }}
    >
      <ReactstrapInput
        {...amountField}
        type="number"
        step={step}
        invalid={!!(amountMeta.touched && amountMeta.error)}
        onChange={handleAmountChange}
        style={{
          minWidth: '60px',
          maxWidth: '60px',
          textAlign: 'right',
        }}
      />
      {availableUnits.length > 1 ? (
        <ReactstrapInput
          {...unitField}
          type="select"
          value={currentUnit}
          onChange={handleUnitChange}
          className="unit-select"
          style={{
            minWidth: '80px',
            maxWidth: '80px',
          }}
        >
          {availableUnits.map((unit) => (
            <option key={unit} value={unit}>
              {unit}
            </option>
          ))}
        </ReactstrapInput>
      ) : (
        <ReactstrapInput type="text" value={currentUnit} disabled />
      )}
    </InputGroup>
  );
};

export default AmountWithUnitInput;
